import styled from "styled-components";

const VerticalSpace = styled.div`
  margin-top: ${({ $amount }) => $amount}px;
`;

export default VerticalSpace;
